import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { VehiclePricingRequest } from "../../types/VehiclePricingRequest";

export const getQuoteDealerPricingRequests = (
  quoteId: string,
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled, defaultOnMutateError } = useAPQuery();

  return useQuery({
    queryKey: ["quoteDealerPricingRequests", quoteId],
    queryFn: (): Promise<VehiclePricingRequest[]> => {
      return fetchWithAuth<VehiclePricingRequest[]>(
        "getQuoteDealerPricingRequests",
        quoteId
      );
    },
    enabled: isQueryEnabled(options),
    onError: defaultOnMutateError(options),
  });
};
